import { Component, CUSTOM_ELEMENTS_SCHEMA, ViewChild } from '@angular/core';
import { PoUploadFile, PoBreadcrumb, PoNotificationService, PoUploadComponent } from '@po-ui/ng-components';
import { environment } from '../../../environments/environment';
import { forkJoin, of, tap } from 'rxjs';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-carga-inicial',
  templateUrl: './processamento-faturas.component.html',
  styleUrls: ['./processamento-faturas.component.css'],
  standalone: false,
})
export class ProcessamentoFaturasComponent {
  @ViewChild('upload', { static: true }) upload!: PoUploadComponent;
  loading = false;
  restrictions = { allowedExtensions: ['.zip'] };
  urlPlaceholder = 'https://po-ui.io';

  readonly breadcrumb: PoBreadcrumb = {
    items: [
      { label: 'Home', link: '/home' },
      { label: 'Integrações' },
      { label: 'Processamento Faturas' }
    ]
  };

  constructor(
    private http: HttpClient,
    private notification: PoNotificationService
  ) { }

  sendArquivos() {
    const files = this.upload?.currentFiles;

    if (!files?.length) {
      this.notification.warning('Selecione pelo menos um arquivo.');
      return;
    }

    this.loading = true;

    files.map((file: any) => {
      const formData = new FormData();
      formData.append('ZipFile', file.rawFile!, file.name);

      return this.http.post(`${environment.apiUrl}/v1/processor/invoice-batch`, formData, {
        responseType: 'blob' as 'json'
      }).subscribe({
        next: (blob: Blob | any) => {
          const link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.download = `${file.name.replace('.zip', '')}_resultado.xlsx`;
          link.click();

          file.status = 0;
          this.notification.success('Arquivo processado com sucesso e baixado!');
          this.upload.clear();
          this.loading = false;
        },
        error: (err) => {
          file.status = 2;
          this.notification.error(`Erro ao processar ${file.name}: ${err.message}`);
          return of(null);
        }
      });
    });
  }
}
